import { gql } from '@apollo/client';

const GET_PERCENTAGE_VISIBILITY_SETTINGS = gql`
  query GetPercentageVisibilitySettings($orgUnitId: Int!) {
    organizationVisibilitySettings(orgUnitId: $orgUnitId) {
      VisibleOnAggregateAppraisalReport
      VisibleOnDetailedAppraisalReport
      VisibleOnAppraisalView
      VisibleOnAppraisalComparison
    }
  }
`;

export default GET_PERCENTAGE_VISIBILITY_SETTINGS;
